import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import hi from "./locales/hi.json";
import te from "./locales/te.json";
import termsEn from "./terms/en.json";
import termsHi from "./terms/hi.json";
import termsTe from "./terms/te.json";

export const SUPPORTED_LANGS = [
  { code: "en", label: "English", native: "English" },
  { code: "hi", label: "Hindi", native: "हिन्दी" },
  { code: "te", label: "Telugu", native: "తెలుగు" },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en, terms: termsEn },
      hi: { translation: hi, terms: termsHi },
      te: { translation: te, terms: termsTe },
    },
    ns: ["translation", "terms"],
    defaultNS: "translation",
    fallbackLng: "en",
    supportedLngs: ["en", "hi", "te"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "lele.lang",
      caches: ["localStorage"],
    },
  });

export default i18n;
